import * as React from 'react';

import { useQuery } from '@apollo/client';
import { compose } from 'recompose';

import { StyleSheet, css, font, spacing } from '@coursera/coursera-ui';

import withSessionsV2EnrollmentEnabled from 'bundles/course-sessions/utils/withSessionsV2EnrollmentEnabled';
import { getFormattedStartDate } from 'bundles/enroll-common/components/StartDateString';
import CourseQuery from 'bundles/enterprise-legacy-learner-home/queries/CourseQueryEnterpriseLegacyLearnerHome.graphql';
import type {
  CourseQueryEnterpriseLegacyLearnerHomeQuery as Query,
  CourseQueryEnterpriseLegacyLearnerHomeQueryVariables as Variables,
} from 'bundles/enterprise-legacy-learner-home/queries/__generated__/CourseQueryEnterpriseLegacyLearnerHome';
import { formatGraphqlCourse } from 'bundles/enterprise-legacy-learner-home/utils/courseUtils';

import _t from 'i18n!nls/enterprise-legacy-learner-home';

const styles = StyleSheet.create({
  StartDateMessage: {
    fontSize: font.xs,
    paddingTop: spacing.xxs,
  },
});

type PropsFromCaller = {
  courseId?: string;
  privateSessionStart?: number;
};

type PropsFromWithSessionsV2EnrollmentEnabled = {
  sessionsV2EnrollmentEnabled?: boolean;
};

type PropsToComponent = PropsFromCaller & PropsFromWithSessionsV2EnrollmentEnabled;

export const StartDateButton = ({
  courseId,
  sessionsV2EnrollmentEnabled = false,
  privateSessionStart,
}: PropsToComponent) => {
  const { loading, error, data } = useQuery<Query, Variables>(CourseQuery, {
    variables: courseId ? { courseId } : undefined,
    context: { clientName: 'gatewayGql' },
    skip: !courseId,
  });

  if (loading || error) return null;

  // Map GraphQL data to existing course object structure
  const courseData = data?.Course?.queryById;
  if (!courseData) {
    return null;
  }
  const mappedCourse = formatGraphqlCourse(courseData);

  return (
    <div className="rc-StartDateButton">
      {_t('Enroll')}
      <div {...css(styles.StartDateMessage)}>
        {mappedCourse && getFormattedStartDate(mappedCourse, sessionsV2EnrollmentEnabled, privateSessionStart)}
      </div>
    </div>
  );
};

export default compose<PropsToComponent, PropsFromCaller>(withSessionsV2EnrollmentEnabled(({ courseId }) => courseId))(
  StartDateButton
);
